import {
  LOCIZE_COMMON_TRANSLATION_KEYS,
  LoginPageViewTypes,
} from 'app-constants';
import { AppContactUs } from 'components';
import type { FC, ReactNode } from 'react';

interface LoginPageProps {
  pageViewType: LoginPageViewTypes;
  loginView: ReactNode;
  pinConfirmationView?: ReactNode;
  idCardView?: ReactNode;
  magicLinkView?: ReactNode;
  pendingView?: ReactNode;
  showContactUs?: boolean;
}

export const LoginPage: FC<LoginPageProps> = ({
  pageViewType,
  loginView,
  pinConfirmationView,
  idCardView,
  magicLinkView,
  pendingView,
  showContactUs = true,
}) => {
  const renderLoginPageContent = () => {
    switch (pageViewType) {
      case LoginPageViewTypes.pinConfirmation:
        return pinConfirmationView;
      case LoginPageViewTypes.idCard:
        return idCardView;
      case LoginPageViewTypes.magic:
        return magicLinkView;
      case LoginPageViewTypes.pending:
        return pendingView;
      default:
        return loginView;
    }
  };

  return (
    <div>
      {renderLoginPageContent()}
      <AppContactUs
        text={LOCIZE_COMMON_TRANSLATION_KEYS.contactInfoDisclaimer}
        visible={showContactUs && pageViewType === LoginPageViewTypes.login}
      />
    </div>
  );
};
